import axios, { AxiosResponse } from 'axios';
export const CDN_ASSET_URL = 'https://cdn.footprinttech.de/assets';

const client = axios.create({
  baseURL: CDN_ASSET_URL,
});

interface LanguageOptions {
  lang: string;
  i18nNamespace?: string;
}

function mergeNamespaceIntoMessages(
  messages:object, options:LanguageOptions) {
  const { lang, i18nNamespace } = options;
  return client.get(`locales/${lang}/${i18nNamespace}.json`)
    .then((result: AxiosResponse) => {
      const nsTranslations = result.data;
      return Object.assign(messages, nsTranslations);
    });
}

export const AssetsService = {
  fetchLanguageFile(options:LanguageOptions) {
    const { lang, i18nNamespace } = options;

    return client.get(`locales/${lang}/messages.json`)
      .then((result: AxiosResponse) => {
        const messages = result.data;

        if (i18nNamespace) {
          return mergeNamespaceIntoMessages(messages, options);
        }

        return messages;
      });
  },
  fetchTheme(themeName: string) {
    return client.get(`themes/${themeName}.json`)
      .then((result: AxiosResponse) => result.data);
  }
};
